/**
 * refresh-report-schemas-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { validateAs, validateFor, validateOpaqueID }
  from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

import { AggregationSchema, DataExportSchema }
  from "../../../aggregation/schemas";

@validateFor(MessageTag.RSP_REFRESH_REPORT_SCHEMAS)
export class RefreshReportSchemasResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_REFRESH_REPORT_SCHEMAS;

  @validateAs({array: "object"})
  public aggregationSchemas : any[];

  @validateAs({array: "object"})
  public dataExportSchemas : any[];
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/export/refresh-report-schemas-response.ts